import React from "react";
import ReactFlow, { Background, ReactFlowProps } from "reactflow";
import { useStore } from "reactflow";
import { customReactFlowBackgroundStyle } from "../../utilities/Constants/style";
import './CustomReactflow.css'
interface CustomReactFlowProps {
  containerRef: React.RefObject<HTMLDivElement>;
  flowStyle?: React.CSSProperties;
  bgProps?: React.ComponentProps<typeof Background>;
  children?: React.ReactNode;
}
const CustomReactFlow = ({
  containerRef,
  flowStyle,
  children,
  bgProps,
  ...restProps
}: CustomReactFlowProps & ReactFlowProps) => {
  const transform = useStore((state) => state.transform);
  const [x, y, zoom] = transform;
  return (
    <div ref={containerRef} className="custom-reactflow-container">
      <ReactFlow
        style={{
          overflowY: "hidden",
          position: 'absolute',
          ...customReactFlowBackgroundStyle(zoom, x, y),
          ...flowStyle,
        }}
        {...restProps}
      >
        <Background color="#888" gap={100} size={1} {...bgProps}/>
        {children}
      </ReactFlow>
    </div>
  );
};
export default CustomReactFlow;